module.exports = __webpack_public_path__ + "static/media/Jobcase_Wordmark_Black.69585170.svg";